import color from "../../../../../constants/color";
const styles = {
  heading: {
    fontSize: "18px",
    fontWeight: "600",
    ml: 2,
    mt: 2,
    lineHeight: "21px"
  },
  subHeading: {
    fontSize: "13px",
    // fontWeight: "500",
    ml: 2,
    lineHeight: "21px"
  },
  dateInput: {
    width: "100%",
    mt: 1,

    // padding:2,
    "& .css-6193sp-MuiInputBase-root-MuiOutlinedInput-root ": {
      borderRadius: "8px",
    },
    "& .MuiInputBase-input": {
      padding: "8.5px 14px",
    }
  },

  mobileGrid: {
    "& .MuiOutlinedInput-root": {
      height: "2.9em",
      marginTop: "0.5em",
      borderRadius: "10px",
      width: "100%",
    },
    ".react-tel-input": {
      width: "100%",
      "& .selected-flag": {
        "& .flag": {
          mt: "-9px",
        }
      },
      ".form-control": {
        borderRadius: "10px",
        mt: "7px",
        // height: "2.5em", // Match height with MUI input
        width: "100%",

      },
    },

  },

  formControl: {
    "& .MuiOutlinedInput-root": {
      height: "2.9em",
      my: "0.5em",
      borderRadius: "10px",
    },
    inputsize: {

    },
  },
  textside: {
    fontSize: "13px",
    ml: "35px"
  },
  textsize: {
    fontSize: "13px",

  },
  changeText: {
    fontSize: "12px",
    fontWeight: "400",
    color: color.text,
    width: { xs: "50%", md: "20%" },
    ml: 1
  },
  dropdown: {
    borderRadius: "10px",
    my: 1,
    height: "2.5em",
  },
  card: {
    backgroundColor: "#fff",
    margin: 2,
    borderRadius: "20px",
    pr: 2,
    paddingBottom: "25px",
    "& .css-a5rdam-MuiGrid-root": {
      marginTop: "11px",
    }
  },
  dropDownMenu: {
    fontSize: "14px",
    fontWeight: "400"
  },
  formControlLabel: {
    m: 0,
    " & .css-1ismtrt-MuiTypography-root": {
      fontSize: "14px",
      width: "100%"
    }
  },
  line: {
    backgroundColor: "#28AA4A",
    width: "2%",
    height: 2
  },

  boxGrid: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    ml: "2%",
    my: "2%"
  },
  pensionGrid: {
    display: "flex",
    alignItems: "center",
    mt: 2
  },
  pensionHeading: {
    fontSize: "18px",
    fontWeight: "600",
    color: color.text,
    mt: 2
  },
  addBtn: {
    fontSize: "12px",
    borderRadius: 50,
    textTransform: "none",
    color: color.card,
    backgroundColor: color.primary,
    // fontWeight: "500",
    px: 4,
    ml: 4,
    "&:hover": {
      color: color.card,
      backgroundColor: color.primary,

    }

  },
  labels: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    mb: 1
  },
  dropdowns: {
    // width:{ xs: "25em", md: "35em" },
    width: "100%",
    p: 0,
    ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      p: 1
    }
  },
  mainGrid: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "top",
    mt: 2,
    mr: 2,
    gap: 1
  },
  additionalButtons: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: color.secondary,
    fontSize: "12px",
    fontWeight: "500",
    px: 4,
    boxShadow: "none",
  },
  dropdownRight: {
    // width:{ xs: "25em", md: "35em" },
    width: "100%",
    p: 0,
    ml: 1,

    ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      p: 1
    }
  },



  pensionText: {
    width: "40%"
  },
  medicalTxt: {
    fontSize: "14px",
  },
  subTitle: {
    fontWeight: "500",
    fontSize: "14px",
    color: color.text,
    ml: 2
  },
  addIcons: {
    p: 1,
    backgroundColor: "#D4EEDB",
    borderRadius: "5px",
    color: color.primary,
    display: "flex",
    justifyContent: "center",
    my: "0.5em",


  },
  deleteIcon: {
    p: 1,
    // pb: 0,
    backgroundColor: "#FBD6D6",
    borderRadius: "5px",
    color: color.red,
    display: "flex",
    justifyContent: "center",
    my: "0.5em",



  },
  btnGridAction: {
    width: "100%",
    ml: { xs: 1, md: 0 }
  },

  addIcon: {
    p: 1,
    backgroundColor: "#D4EEDB",
    borderRadius: "5px",
    color: color.primary,
    textAlign: "center"
  },
  deleteIcons: {
    p: 1,
    // pb:0,
    backgroundColor: "#FBD6D6",
    borderRadius: "5px",
    color: color.red,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"

  },
  exportBtn: {
    borderRadius: 50,
    color: color.secondary,
    border: "1px solid #00ABF4",
    ml: "8px",
    textTransform: "none",
    fontSize: "12px",
    boxShadow: "none",
    py: "4px",
    px: "8px",
    "& svg": {
      mr: 1
    }
  }
};

export default styles;